import React from "react";
import { HorizRule, Img } from "../core/pdf/types";
import { useContentState } from "./useContentState";
// import { useDesigner } from "./useDesigner";
import { ElementContext, useElementContext } from "./useElementContext";
import { toMillimeters } from "../core/pdf/utils";
import { useDesigner } from "./useDesigner";
import { Icon } from "../core/ui/icons";
import { api } from "../api/api";

export function ImageEditor(props: {
	image: Img,
}) {
	const designer = useDesigner();

	const image = props.image;

	const elementContext = useElementContext(image);

	const state = useContentState(elementContext, React.useCallback((msg: any) => {

	}, []));

	const style = designer.createStyle(props.image);

	let w = toMillimeters(image.width);
	let h = toMillimeters(image.height);
	if (image.scale) {
		w *= image.scale / 100;
		h *= image.scale / 100;
	}
	const imageStyle = {
		width: w + "mm",
		height: h + "mm",
		display: "inline-block",
	} as any;

	let elImage;
	if (image.image && image.image.blob) {
		const url = api.getDownloadSystemUrl(image.image.blob);
		elImage = (
			<img 
				src={url}
				style={imageStyle}
			/>			
		);
	} else {
		elImage = <Icon type="photo_color" />;
	}

	return (
		<ElementContext.Provider value={elementContext}>
			<div
				className={"image content-element " + state.classes}
				data-key={image.id}
				id={state.elementID}
				tabIndex={0}
				style={style}
			>
				{elImage}
			</div>
		</ElementContext.Provider>
	);
}
